import * as designSystem from '@acceso/design-system';
import i18n from 'i18next';
import detector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import { LANGUAGE_KEY } from '@/constants';
import { Locale } from '@/types';
import { getLocaleFromString } from '@/utils/i18n.utils';

import ca_CA from './locales/ca';
import en_US from './locales/en';
import es_ES from './locales/es';
import eu_EU from './locales/eu';

export type Translation = typeof es_ES.translations;

const availableLanguages: Record<'en' | 'es' | 'ca' | 'eu', Locale> = {
  en: 'en_US',
  es: 'es_ES',
  ca: 'ca_CA',
  eu: 'eu_EU',
};

const getInitialLanguage = () => {
  const savedLanguage =
    typeof localStorage !== 'undefined' && typeof localStorage.getItem === 'function'
      ? localStorage.getItem(LANGUAGE_KEY)
      : null;
  if (savedLanguage) {
    return savedLanguage;
  }

  const browserLanguage = typeof navigator !== 'undefined' ? navigator.language : 'es';
  const languageCode = browserLanguage.split('-')[0] as 'en' | 'es' | 'ca' | 'eu';

  return availableLanguages[languageCode] || 'es_ES';
};

export const resources = { en_US, es_ES, ca_CA, eu_EU };
export const defaultNS = 'translations';

i18n.use(detector).use(initReactI18next).init({
  fallbackLng: 'es_ES',
  lng: getInitialLanguage(),
  resources,
  defaultNS,
  returnNull: false,
  debug: false,
});

export const LOCALES: Locale[] = ['en_US', 'es_ES', 'ca_CA', 'eu_EU'];

i18n.languages = LOCALES;

export const changeAppLanguage = (lng: Locale) => {
  i18n.changeLanguage(lng);
  designSystem.changeLanguage(lng);
};

export const storeAppLanguage = (lng: Locale) => {
  localStorage.setItem(LANGUAGE_KEY, lng);
  changeAppLanguage(lng);
};

export const getStoredAppLanguage = (): Locale | null => {
  const storedLanguage = localStorage.getItem(LANGUAGE_KEY);

  if (!storedLanguage) {
    return null;
  }

  const language = getLocaleFromString(storedLanguage);

  return language;
};

export default i18n;
